import { AbstractApiModel } from '@ng-cloud/badger-core/models/abstract-api-model';

export class NonShelfViewport extends AbstractApiModel<NonShelfViewport> {
  skuString: string;
  viewportHeight: number;
  viewportOffsetX: number;
  viewportOffsetY: number;
  viewportWidth: number;
  organizationId: number;
  storeId: number;
  updatedById: number;

  deserialize(json: any): this {
    this.skuString = json.sku_string;
    this.viewportHeight = +json.viewport_height;
    this.viewportOffsetX = +json.viewport_offset_x;
    this.viewportOffsetY = +json.viewport_offset_y;
    this.viewportWidth = +json.viewport_width;
    this.organizationId = +json.organization_id;
    this.storeId = +json.store_id;
    this.updatedById = json.updated_by_id;

    return super.deserialize(json);
  }

  serialize(): any {
    return Object.assign(super.serialize(), {
      sku_string: this.skuString,
      viewport_height: this.viewportHeight,
      viewport_offset_x: this.viewportOffsetX,
      viewport_offset_y: this.viewportOffsetY,
      viewport_width: this.viewportWidth,
      organization_id: this.organizationId,
      store_id: this.storeId,
      updated_by_id: this.updatedById
    });
  }

}
